import { Box } from '@mui/material'
import CustomTabPanel from 'components/custom-tab-panel'
import InError from 'components/error'
import Header from 'components/header'
import { HeaderModule } from 'components/header-module'
import Loading from 'components/loading'
import Page from 'components/page'
import Wrapper from 'components/wrapper'
import WrapperWithHeader from 'components/wrapper-with-header'
import { useProject } from 'contexts/project'
import { useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import useContract from 'store/contracts'
import ProjectViewConnectorsAndApps from './connectos-and-apps'
import ProjectHeader from './header'
import ProjectInputTablesView from './input-tables'
import { useStyles } from './styles'
import ProjectTablesView from './tables'
import ProjectWorkFlowView from './workflow'

interface IRouteParams {
  id: string
  organizationId: string
  contractId: string
}

const ProjectView = () => {
  const { data: project, changeProjectId, isLoading, selectedTab, isError } = useProject()
  const { rollbackUrl } = useContract()
  const { id, organizationId, contractId } = useParams<IRouteParams>()
  const classes = useStyles()
  const history = useHistory()

  const handleBackPage = () => {
    if (rollbackUrl != '') {
      history.push(rollbackUrl)
    } else {
      history.push('/customers')
    }
  }

  useEffect(() => {
    if (id) {
      changeProjectId(id)
    }
  }, [id, isLoading])

  if (isLoading) {
    return (
      <WrapperWithHeader>
        <Box className={classes.root}>
          <Loading />
        </Box>
      </WrapperWithHeader>
    )
  }

  if (isError) {
    return (
      <WrapperWithHeader>
        <InError message='Error ao Carregar o Projeto' />
      </WrapperWithHeader>
    )
  }

  const tables = project?.recipes?.map((recipe) => recipe.tables).flat()

  return (
    <Wrapper>
      <Header>
        <HeaderModule.title
          text={project.name}
          backRoute={rollbackUrl != '' ? rollbackUrl : '/customers'}
        />
        <ProjectHeader handleBackPage={handleBackPage} />
      </Header>
      <Page>
        <Box className={classes.root}>
          <CustomTabPanel
            value={selectedTab}
            index={0}
          >
            <ProjectWorkFlowView organizationId={organizationId} contractId={contractId} />
          </CustomTabPanel>

          <CustomTabPanel
            value={selectedTab}
            index={1}
          >
            <ProjectInputTablesView
              tables={project.entryTables}
              projectId={project.id}
              organizationId={organizationId}
            />
          </CustomTabPanel>

          <CustomTabPanel
            value={selectedTab}
            index={2}
          >
            <ProjectTablesView
              projectId={project.id}
              tables={project.outputTables}
              organizationId={organizationId}
            />
          </CustomTabPanel>

          <CustomTabPanel
            value={selectedTab}
            index={3}
          >
            <ProjectViewConnectorsAndApps />
          </CustomTabPanel>

          <CustomTabPanel
            value={selectedTab}
            index={4}
          >
            Historico
          </CustomTabPanel>

          <CustomTabPanel
            value={selectedTab}
            index={5}
          >
            Processo
          </CustomTabPanel>
        </Box>
      </Page>
    </Wrapper>
  )
}

export default ProjectView
